import { render, staticRenderFns } from "./ciic-tinymce-editor.vue?vue&type=template&id=1994a39e&"
import script from "./ciic-tinymce-editor.vue?vue&type=script&lang=js&"
export * from "./ciic-tinymce-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports